const $ = require('jquery');

export function initSlideShows() {
    const slickPrev = '<button class="slick-prev">Prev</button>';
    const slickNext = '<button class="slick-next">Next</button>';

    //Post Content Slider
    $('.archive__slider-post').slick({
        rows: 0,
        infinite: true,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipe: true,
        swipeToSlide: true,
        autoplay: false,
        adaptiveHeight: true,
        fade: true,
        cssEase: 'linear',
        appendArrows: '.slick-slide .featured-post__content .slider-nav',
    });

    $('.archive__slider-post .slider-nav .slick-prev').on('click', function(){
        $('.archive__slider-post').slick("slickPrev");
    });
    $('.archive__slider-post .slider-nav .slick-next').on('click', function(){
        $('.archive__slider-post').slick("slickNext");
    });

    $('.js-product-slider').slick({
        rows: 0,
        infinite: false,
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        nextArrow: slickNext,
        prevArrow: slickPrev,
    });

    //Product Content Slider
    $('.archive__slider-product').slick({
        rows: 0,
        infinite: true,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipe: true,
        swipeToSlide: true,
        autoplay: false,
        adaptiveHeight: true,
        fade: true,
        cssEase: 'linear',
        appendArrows: '.archive__slider-product .slick-slide .slider-nav',
    });

    $('.archive__slider-product .slider-nav .slick-prev').on('click', function(){
        $('.archive__slider-product').slick("slickPrev");
    });
    $('.archive__slider-product .slider-nav .slick-next').on('click', function(){
        $('.archive__slider-product').slick("slickNext");
    });


    //Things Slider
    $('.things-callout__images').slick({
        rows: 0,
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        swipe: true,
        swipeToSlide: true,
        adaptiveHeight: false,
        fade: false,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            },
        ],
    });
}